<nz-tabset nzSize="large" [nzSelectedIndex]="index" [nzAnimated]="false">
  <nz-tab [nzTitle]="'component.sidebar.tab_price' | translate" (nzClick)="updateTabIndex('channel-price')">
    <div class="content">
      <host-house-price
        #priceCMP
        [listOfCalendar]="listOfPriceCalendar"
        [entity]="entity"
        [listOfForbiddenDates]="listOfForbiddenDates"
        [dateRange]="dateRange"
        (success)="onClickCancel()"></host-house-price>
    </div>
  </nz-tab>
  <nz-tab
    [nzTitle]="'operate_sidebar_html_tab_rules' | translate"
    *ngIf="listOfRulesSettingHouse?.length"
    (nzClick)="updateTabIndex('rules-setting')">
    <div class="content">
      <os-price-rules-setting
        [dateRange]="dateRange"
        [entity]="entity"
        [listOfHouse]="listOfRulesSettingHouse"
        (success)="onClickCancel()"
        (onUpdated)="onUpdated.emit()"></os-price-rules-setting>
    </div>
  </nz-tab>
  <nz-tab
    [nzTitle]="
      (entity?.c_parent?.p_type === 0
        ? 'component.sidebar.tab_channel_house_status'
        : 'component.sidebar.tab_channel_inventory'
      ) | translate
    "
    (nzClick)="updateTabIndex('channel-status')">
    <div class="content">
      <host-channel-panel
        [listOfCalendar]="listOfPriceCalendar"
        [entity]="entity"
        [dateRange]="dateRange"
        (success)="onClickCancel()"></host-channel-panel>
    </div>
  </nz-tab>
</nz-tabset>
